module.exports = __webpack_public_path__ + "img/building2.0acad994.jpg";